import React from 'react';
import Logo from '../Icons/Logo';
import Link from 'next/link';
import { useRouter } from 'next/router';

const Footer = () => {
  const router = useRouter();

  return (
    <footer className="w-full bg-footerBg border-b-5 border-blue">
      <div className="w-full bg-footer text-white flex items-center justify-center desktop:px-12 phone-150:px-6">
        <div className="max-w-xxl w-full">
          <div className="border-t-1 border-gray/20 py-7 flex justify-between items-center phone-100:text-xs">
            <p>WEBSITE IS LICENCED BY TEOSTO/NCB. Copyright © Virtuaalikirkko.</p>
            <p>
              {/* <Link href="/tietosuojaseloste">
                <a className="border-b-1 border-white">Tietosuojaseloste</a>
              </Link> */}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
